export const APP_ONE_LINK = 'https://gzl.onelink.me/UpQ4';
